module.exports = __webpack_public_path__ + "static/img/04.d50814e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sub/worship/04.png
// module id = zNtz
// module chunks = 1